import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import {CloudStagingListEvents, osTypes} from "../../cloudStagingList/types";
import {KitTypes} from "../../../packages/downloadKitButtonSelector/constants";

/**
 * @summary Type here the description of this component
 * @tag cloud-staging-side-bar
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('cloud-staging-side-bar')
export class CloudStagingSideBarWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({ type: String, reflect: true })
  label = '';

  @property({ type: String, reflect: true })
  activeButton = 'windows';

  @property({ type: String, reflect: true })
  windows = '';

  @property({ type: String, reflect: true })
  mac = '';

  @property({ type: String, reflect: true })
  linux = '';

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="cloud-staging-side-bar">
        <div class="cloud-staging-side-bar--body">
          <gz-title class="title" fontweight="600" fontsize="11">${this.label}</gz-title>
          <gz-list-item @click="${this.showWindows}" .active="${this.isButtonActive('windows')}"
            >${this.windows}</gz-list-item
          >
          <gz-list-item @click="${this.showMac}" .active="${this.isButtonActive('mac')}"
            >${this.mac}</gz-list-item
          >
          <gz-list-item @click="${this.showLinux}" .active="${this.isButtonActive('linux')}"
            >${this.linux}</gz-list-item
          >
        </div>
      </div>
    `;
  }

  isButtonActive(button: string) {
    return this.activeButton === button;
  }

  constructor() {
    super();
  }

  showLinux() {
    this.activeButton = 'linux';

    this.dispatchEvent(
      new CustomEvent(CloudStagingListEvents.SHOW_OS, {
        detail: {type: osTypes.linux},
        bubbles: true,
        composed: true,
      })
    );
  }

  showWindows() {
    this.activeButton = 'windows';

    this.dispatchEvent(
      new CustomEvent(CloudStagingListEvents.SHOW_OS, {
        detail: {type: osTypes.windows},
        bubbles: true,
        composed: true,
      })
    );
  }

  showMac() {
    this.activeButton = 'mac';

    this.dispatchEvent(
      new CustomEvent(CloudStagingListEvents.SHOW_OS, {
        detail: {type: osTypes.mac},
        bubbles: true,
        composed: true,
      })
    );
  }
}



declare global {
  interface HTMLElementTagNameMap {
    'cloud-staging-side-bar': CloudStagingSideBarWebComponent;
  }
}
